import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordPage } from '../components/auth/ForgotPasswordPage';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPassword,
});

function ForgotPassword() {
  return <ForgotPasswordPage />;
}
